import { Link } from 'react-router-dom';

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="max-w-8xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-10 rounded-lg bg-accent-500 flex items-center justify-center text-primary-950 font-heading text-xl font-bold">
                翔
              </span>
              <span className="font-heading text-xl font-bold text-background-50">翔田千里影视大全</span>
            </div>
            <p className="text-sm leading-relaxed text-background-300 max-w-md">
              翔田千里专注于提供丰富的影视资源和资讯，汇聚最新电影、电视剧信息与行业动态，为每一位影视爱好者打造流畅、专业的观影发现体验。
            </p>
            <div className="flex items-center gap-3 mt-6">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 text-background-200 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 text-background-200 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 text-background-200 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer">
                <i className="ri-youtube-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 text-background-200 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50 mb-4">快速导航</h3>
            <ul className="flex flex-col gap-3 text-sm text-background-300">
              <li><Link to="/" className="hover:text-accent-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category?type=movie" className="hover:text-accent-400 transition-colors cursor-pointer">电影专区</Link></li>
              <li><Link to="/category?type=tv" className="hover:text-accent-400 transition-colors cursor-pointer">电视剧专区</Link></li>
              <li><Link to="/news" className="hover:text-accent-400 transition-colors cursor-pointer">影视资讯</Link></li>
              <li><Link to="/search" className="hover:text-accent-400 transition-colors cursor-pointer">全站搜索</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h3>
            <ul className="flex flex-col gap-3 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400"></i>
                <span>contact@xiangtianqianli.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-accent-400"></i>
                <span>400-888-6688</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-accent-400"></i>
                <span>北京市朝阳区影视文化产业园 A 座</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-900">
        <div className="max-w-8xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2024 翔田千里影视大全 · 保留所有权利</p>
          <p className="flex items-center gap-4">
            <span className="cursor-pointer hover:text-accent-400 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-accent-400 transition-colors">用户协议</span>
            <span>本站内容仅供学习交流</span>
          </p>
        </div>
      </div>
    </footer>
  );
}